import rg4js from "raygun4js";
import React from "react";
import { SYN_REDIRECT } from "../../utility/constants";
import { Break } from "../Shared/Layout/Layout";
import LinkButton from "../Shared/Link/Link";
import { Container, ErrorDescription, ErrorHeader } from "./Styles";

export default function NotFound() {
  rg4js("send", { error: "Landed on Not Found page" });
  window.analytics.page("Not found");
  return (
    <Container>
      <ErrorHeader>Úps... hvað gæti hafa gerst?</ErrorHeader>
      <ErrorDescription style={{ maxWidth: "600px" }}>
        Síðan sem þú varst að leita að er því miður ekki á þessari slóð. Hún
        gæti hafa verið færð, henni eytt eða einhver mistök mögulega verið gerð.
        Ef þú lendir áfram í vandræðum getur þú haft samband við okkur í gegnum
        Netspjallið eða þjónustuver Sýnar í síma 1414.
      </ErrorDescription>
      <Break />
      <LinkButton to={SYN_REDIRECT} label="Fara á syn.is" />
    </Container>
  );
}
